import { Outlet } from '@tanstack/react-router';

import { Box } from '@src/components';
import { useAuthentication, useSidebar } from '@src/context/hooks';
import pallete from '@src/themes/palette';

const StyleSheet = {
  main: ({ isCollapsed }) => ({
    flexGrow: 1,
    marginTop: (t) => `${t.layout.header.height}px`,
    height: (t) => `calc(100% - ${t.layout.header.height}px)`,
    width: (t) => `calc(100% - ${isCollapsed ? t.layout.sidebar.minWidth : t.layout.sidebar.maxWidth}px)`,
    backgroundColor: 'layout.main.light',
    overflow: 'auto',
    minHeight: '100vh',
    padding: '24px',
    position: 'relative',
  }),
  loginAsNotification: {
    position: 'absolute',
    top: '10px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: pallete.red[500],
    padding: '0 16px',
    opacity: 0.8,
  },
};


export default function Main() {
  const { isCollapsed } = useSidebar();
  const { user, credentials: { loginAs } } = useAuthentication();
  return (
    <Box sx={StyleSheet.main({ isCollapsed })} component="main">
      {loginAs && (
        <Box sx={StyleSheet.loginAsNotification}>
          Login as {user.name}
        </Box>
      )}
      <Outlet />
    </Box>
  );
}
